import { Components } from '@mui/material/styles/components';
import { Theme } from '@mui/material/styles/createTheme';

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    slim: true;
  }
}

// todo: check styles
//       the ones that change color should only apply to 'standard' variant
//       those which modify shape/size/border should apply to every variant
export const ThemeMuiButton: Components<Omit<Theme, 'components'>>['MuiButton'] = {
  variants: [
    {
      props: { variant: 'slim', size: 'small' },
      style: {
        backgroundColor: '#EDF3F9',
        color: '#636F85',
      }
    }
  ]
};
